/**
 * 日语
 */
var jaJP = {
  locale: 'ja-JP',
  Common: {
    pleaseInput: '入力してください',
    pleaseSelect: '選択してください',
    confirm: '確認',
    clear: 'クリア',
    cancel: 'キャンセル',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    reset: 'リセット'
  },
  Exception: {
    emptyData: 'データがありません',
    error: 'ページエラー。後でもう一度お試しください',
    networkError: 'ネットワークエラー'
  },
  List: {
    noMoreData: 'これ以上データはありません',
    networkError: 'ネットワークエラー',
    clickRetry: '再試行をクリック'
  },
  DateRangePicker: {
    startTime: '開始時間',
    endTime: '終了時間',
    timeRange: '時間範囲'
  }
};

export { jaJP as default };
